import styles from "./loader.module.css"
import {CSSProperties} from "react";

type Props = {
    isLoading?: boolean,
    style?: CSSProperties
}

const LoadingBars = (
    {isLoading = true, style = {}}: Props
) => {
    if (!isLoading) {
        return <></>;
    }

    return <div style={style} className={styles.loader}><div></div><div></div><div></div></div>
}

export default LoadingBars;
